import { ReactElement, ReactNode } from 'react';
import FormGroup, { FormGroupProps } from 'components/FormGroup';
import Switch, { SwitchProps } from 'components/Switch';
import classlist from 'utils/classlist';

export interface SwitchFormutilProps<T = string | boolean>
    extends Omit<FormGroupProps<T>, 'type' | 'onClick'>,
        Pick<SwitchProps, 'onClick' | 'type' | 'inline' | 'reverse' | 'underline'> {
    disabled?: boolean;
    className?: string;
    label: ReactNode;
    name: string;
}

const SwitchFormutil: <T>(props: SwitchFormutilProps<T>) => ReactElement<SwitchFormutilProps<T>> = ({
    name,
    label,
    disabled,
    className,
    inline,
    // 作为表单项reverse 和 underline是最常用的
    reverse = true,
    underline = true,
    // 勾选状态的值
    checked = true,
    // 未勾选状态的值
    unchecked = false,
    type,
    onClick,
    ...restProps
}) => {
    return (
        <FormGroup
            className={classlist('switch-formutil-root', className)}
            name={name}
            checked={checked}
            unchecked={unchecked}
            {...restProps}>
            <Switch
                id={name}
                type={type}
                disabled={disabled}
                inline={inline}
                reverse={reverse}
                underline={underline}
                label={label}
                onClick={onClick}
            />
        </FormGroup>
    );
};

export default SwitchFormutil;
